import type { ReactNode } from 'react';

export const symbol_golf_course: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M791-123q-20 0-34.5-14.5T742-172q0-20 14.5-34.5T791-221q20 0 34.5 14.5T840-172q0 20-14.5 34.5T791-123ZM396-80q-97 0-166.5-19T160-149q0-21 40-39.5t94-27.5v40q0 15 10.5 25.5T330-140q15 0 25.5-10.5T366-176v-656q0-17 14-26t29-1l196 95q17 8 17.5 27T606-710l-180 94v396q90 5 148 25t58 46q0 31-69.5 50T396-80Z"
		/>
	</svg>
);
